import { Checkbox } from '@/shared/components/ui/checkbox'
import { cn } from '@/shared/lib/utils'

type BooleanFilterProps = {
  id: string
  checked: boolean
  label: string
  onChange: (checked: boolean) => void
  disabled?: boolean
  /** Helper under the control (e.g. why the filter is disabled). */
  hint?: string
}

export function BooleanFilter({
  id,
  checked,
  label,
  onChange,
  disabled = false,
  hint,
}: BooleanFilterProps) {
  const hintId = hint ? `${id}-hint` : undefined
  return (
    <div className="space-y-1">
      <label
        htmlFor={id}
        className={cn(
          'flex min-h-10 items-center gap-2 rounded-md border border-border px-3 text-sm',
          disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
        )}
      >
        <Checkbox
          id={id}
          checked={checked}
          disabled={disabled}
          aria-describedby={hintId}
          onCheckedChange={(next) => {
            if (!disabled) onChange(next === true)
          }}
        />
        <span>{label}</span>
      </label>
      {hint ? (
        <p id={hintId} className="px-1 text-xs text-muted-foreground">
          {hint}
        </p>
      ) : null}
    </div>
  )
}
